<template lang="html">

  <div class="horas-selector row-start ais" :error="error">

    <h4>{{label}}</h4>

    <div class="contenedor-horas row-start">

      <template v-for="(hora,key) in horas">

        <div class="hora">
          <input type="checkbox" :value="hora" v-model="selected" :id="label+hora" @change="$emit('input',selected)">
          <label :for="label+hora">{{hora | string}}</label>
        </div>

        <span class="split" v-if="key == 11"></span>

      </template>

    </div>

  </div>

</template>

<script lang="js">
  export default  {
    name: 'horas-selector',
    props : ['label','error'],
    data(){
      return{
        selected : [],
        horas : [6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,0,1,2,3,4,5]
      }
    },
    filters : {
      string(value){
        let number;

        if(value <= 9){
          number  = '0'+value;
        }else{
          number  = value;
        }

        return number;
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';

  .horas-selector{
    width: 100%;
    margin-bottom: 20px;
  }

  h4{
    width: 150px;
  }

  .contenedor-horas{
    width: calc(100% - 150px);
    justify-content: space-around;
  }

  .hora{
    position: relative;
    text-align: center;
    margin-bottom: 10px;

    &:nth-child(12n){
      margin-right: 0;
    }
    
    input{
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }

    label{
      font-size: 16px;
      font-weight: 800;
      border:1px solid $purple;
      width: 50px;
      height: 50px;
      display: inline-block;
      line-height: 50px;
      border-radius: 5px;
    }

    input:checked + label{
      background: $orange;
      color: white;
      border-color: $orange;
    }

  }

  .split{
    width: 100%;
    display: inline-block;
  }

  [error=true]{
    .hora{
      label{
        color: $rojo;
        border-color:$rojo;
      }
    }
  }

  @media screen and (max-width: 1000px){
    .contenedor-horas{
      width: 100%;
      max-width: 745px;
    }
  }

  @media screen and (max-width: 850px){

   .contenedor-horas{
    width: 100%;
    max-width: 440px;
    .split{
      display: none;
    }
  }


}

@media screen and (max-width: 520px){

  .contenedor-horas{
    max-width: 100%;
    justify-content: space-between;
    -webkit-justify-content: space-between;
  }

  .hora{
    margin-right: 0;
    width: calc((100vw - 30px) / 6 - 7px);
    height: calc((100vw - 30px) / 6 - 7px);
  
    
    label{
      width: 100%;
      height: 100%;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      -ms-align-items: center;
      align-items: center;
      justify-content: center;
      font-size: 18px;
    }



    &:nth-child(6n){
      margin-right: 0px;
    }
      &:nth-child(8n){
      margin-right: 0px;
    }
  }

}



</style>



// WEBPACK FOOTER //
// src/components/view-parts/simulador/horas-selector.vue